module.exports = __webpack_public_path__ + "static/media/pavani.c8faaf4d.jpg";